import {
  faAddressBook, faBullhorn, faCalendarDay, faChartLine,
  faCubes, faFileAlt, faFileInvoice,
  faHeadphones,
  faHome, faLayerGroup, faList, faPlus,
  faQuestion,
  faRuler, faTrafficLight,
  faTruck,
  faUsers, faVideo, faEye, faEnvelope, faSave, faTimes, faTrash, faPaperPlane, faFolderPlus, faUpload, faPencil,
  faImage
} from "@fortawesome/pro-light-svg-icons";

import {
  faQuestionCircle
} from "@fortawesome/pro-regular-svg-icons";

export const iconsSet = {
  faHome,
  faTruck,
  faCubes,
  faRuler,
  faQuestion,
  faUsers,
  faHeadphones,
  faAddressBook,
  faList,
  faPlus,
  faCalendarDay,
  faBullhorn,
  faFileAlt,
  faFileInvoice,
  faTrafficLight,
  faLayerGroup,
  faVideo,
  faChartLine,
  faEye,
  faEnvelope,
  faSave,
  faTimes,
  faTrash,
  faPaperPlane,
  faFolderPlus,
  faUpload,
  faImage,
  faQuestionCircle,
  faPencil
};